import LogoMain from "../../assets/imgs/logo-main.png"
import IconOffer from "../../assets/icons/icon-offer.png"
import IconUser from "../../assets/icons/icon-users.png"
import IconLogout from "../../assets/icons/icon-logout.png"
import IconAdminUsers from "../../assets/icons/icon-admin-users.png";
import { getRole } from '../../services/token'; // Add this import

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LOGOUT_USER } from "../../constants/types"
import { logoutAdmin } from '../../services/requests';
import "./Sidebar.css"

export default function Layout({ children }) {

    const navigate = useNavigate()
    const dispatch = useDispatch();

    async function handleLogoutClick() {
        await logoutAdmin();
        dispatch({ type: LOGOUT_USER });
        navigate('/')
    }

    function handleOffersClick() {
        navigate('/admin/offers')
    }

    function handleUsersClick() {
        navigate('/admin/users')
    }

    function handleAdminUsersClick() {
        navigate('/admin/admin-users')
    }

    return (
    <>
<div className="container-fluid website__background">
    <div className="row flex-nowrap">
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark sidebar__container">

            <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
                <div className="sidebar__logo-container">
                    <img src={LogoMain} style={{width: '119px'}} 
                        className="sidebar__logo" alt="" />
                </div>
                <hr className="sidebar__hr"/>

                <ul className="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start" 
                    id="menu"
                    style={{backgroundColor: '#2c2f1f', width:'100%'}}>

                    <li className="nav-item">
                        <img className="sidebar__offers-icon" src={IconOffer} alt=""/>
                        <span className="ms-1 d-none d-sm-inline sidebar__link" 
                            onClick={() => handleOffersClick()}>Special Offers</span>                        
                    </li>

                    <hr className="sidebar-menu__hr"/>    

                    <li className="nav-item">
                        <img className="sidebar__offers-icon" src={IconUser} alt=""/>
                        <span className="ms-1 d-none d-sm-inline sidebar__link" 
                            onClick={() => handleUsersClick()}>App Users</span>                        
                    </li>

                    {getRole() === 'superadmin' && (
                      <>
                        <hr className="sidebar-menu__hr"/>    
                        <li className="nav-item">
                            <img className="sidebar__offers-icon" src={IconAdminUsers} alt=""/>
                            <span className="ms-1 d-none d-sm-inline sidebar__link" 
                                onClick={() => handleAdminUsersClick()}>Admin Users</span>                        
                        </li>
                      </>
                    )}
                </ul>

                <hr className="sidebar__hr"/>
                <div className="pb-4">
                <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
                    <li className="nav-item sidebar__logout-link">    
                        <img className="sidebar__offers-icon" src={IconLogout} alt=""/>
                        <span className="ms-1 d-none d-sm-inline sidebar__link" 
                            onClick={() => handleLogoutClick()}>Log out</span>                        
                    </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="col py-3">
        {children}
        </div>
    </div>
</div>
    </>
  )
}